import React from 'react';
import useCountUp from '../../hooks/useCountUp';

const defaultFormat = (n) => n.toLocaleString('pt-BR');

const formatBR2 = (n) => n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Valor monetário que a API devolve já formatado em pt-BR ("1.234,56").
// Converte para número, anima em centavos e formata igual ao texto original
// (sem o prefixo "R$", que fica por conta de quem chama via `prefix`). Se o
// texto não for reproduzível pelo formatador (formato inesperado), mostra o
// original sem animar, garantindo o mesmo valor final de antes.
export function AnimatedMoney({ value, prefix = 'R$ ', duration = 900 }) {
    const raw = value === undefined || value === null ? '' : String(value);
    const parsed = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
    const reproducible = Number.isFinite(parsed) && formatBR2(parsed) === raw;
    if (!reproducible) return <span>{prefix}{raw}</span>;
    return <AnimatedNumber value={parsed} decimals={2} duration={duration} format={(n) => `${prefix}${formatBR2(n)}`} />;
}

// Número com animação "count up". `format` recebe o número corrente e devolve
// o texto (o mesmo formatador do valor final, ex.: `R$ ${formatBRMoney(n)}`).
// `decimals` = casas do valor animado (2 para dinheiro, 1 para percentual).
// Valor não numérico é exibido como está.
export default function AnimatedNumber({ value, format = defaultFormat, decimals = 0, duration = 900 }) {
    const current = useCountUp(value, { duration, decimals });
    const text = typeof current === 'number' && Number.isFinite(current) ? format(current) : current;
    return (
        <span style={{ fontVariantNumeric: 'tabular-nums' }}>{text}</span>
    );
}
